import { Map,Record } from "immutable";

import createFromJS from "../../createFromJS";
import { TreeRecord } from "../model/data/TreeRecord";

export const SyncUpdateCollectionRecord = Record({
  updatesById: new Map(),
  visualMergeTree: new TreeRecord()
});

const data = {
  collections: {
    updatesById: "SyncUpdateRecord"
  },
  objects: {
    visualMergeTree: "TreeRecord"
  }
};
createFromJS.registerCallback(
  "SyncUpdateCollectionRecord",
  createFromJS.createNestedCallback(SyncUpdateCollectionRecord, data)
);
